import {Pipe, PipeTransform} from "@angular/core";
import {ComparatorService} from "../../services/comparator-service";
import {GlaeubigerMasterDetailEntryMeta, SchuldnerMasterDetailEntryMeta} from "../../../core/gb-api";

@Pipe({
  name: 'orderByGlaeubigerSchuldnerMaster'
})
export class OrderByGlaeubigerSchuldnerMasterPipe implements PipeTransform {

  public constructor(private comperatorService: ComparatorService) {
  }

  transform(array, ascending = true): Array<GlaeubigerMasterDetailEntryMeta | SchuldnerMasterDetailEntryMeta> {
    if (ascending) {
      return Array.from(array).sort((item1: GlaeubigerMasterDetailEntryMeta | SchuldnerMasterDetailEntryMeta, item2: GlaeubigerMasterDetailEntryMeta | SchuldnerMasterDetailEntryMeta) => {
        return this.comperatorService.glaeubigerSchuldnerMasterComparator(item1, item2);
      });
    } else {
      return Array.from(array).sort((item1: GlaeubigerMasterDetailEntryMeta | SchuldnerMasterDetailEntryMeta, item2: GlaeubigerMasterDetailEntryMeta | SchuldnerMasterDetailEntryMeta) => {
        return this.comperatorService.glaeubigerSchuldnerMasterComparator(item1, item2);
      });
    }
  }

}
